import { UserState } from './types';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export { namespace } from './types';

export const state: UserState = {
  currentUser: undefined,
  isLogged: false,
  errorMessage: '',
  masterAccounts: [],
  selectedMasterAccount: {
    id: 0,
    name: '',
    vdoName: '',
    routeId: '',
    dsrcKeysEncryption: false
  }
};

const namespaced = true;

export const module = {
  namespaced,
  state,
  actions,
  getters,
  mutations
};
